import { graphql } from '~/graphql/generated/gql';

export const blockUnionFragment = graphql(`
  fragment BlockUnionFields on LearningContentItemUnion {
    ... on TextItem {
      id
      type
      content
    }

    ... on HeaderItem {
      id
      type
      content
    }

    ... on ImageItem {
      id
      type
      altText
      file {
        id
        name
        path
        mimeType
        size
      }
    }

    ... on VideoItem {
      id
      title
      url
      type
      videoOptions {
        autoplay
        orientation
      }
    }

    ... on MultiChoiceSingleResponseItem {
      id
      type
      requireCorrectAnswer
      question
      correctAnswerSingle
      options {
        label
        value
      }
      rightAnswerExplanation
      wrongAnswerExplanation
    }

    ... on MultiChoiceMultiResponseItem {
      id
      type
      requireCorrectAnswer
      question
      correctAnswerMultiple
      options {
        label
        value
      }
      rightAnswerExplanation
      wrongAnswerExplanation
    }

    ... on TrueFalseItem {
      id
      type
      requireCorrectAnswer
      question
      correctAnswerBoolean
      options {
        label
        value
      }
      rightAnswerExplanation
      wrongAnswerExplanation
    }
    ... on TermsAndConditionsItem {
      id
      type
      requireCorrectAnswer
      question
      correctAnswerSingle
      options {
        label
        value
      }
      rightAnswerExplanation
      wrongAnswerExplanation
    }
    ... on CardSortingItem {
      id
      type
      question
      cards {
        question
        correctAnswer
      }
      options {
        label
        value
      }
      completeMessage
    }

    ... on DragOrderingItem {
      id
      type
      requireCorrectAnswer
      question
      correctAnswerOrder
      options {
        icon
        iconColor
        emoji
        label
        value
        activeVisual
      }
    }

    ... on DragPairingItem {
      id
      type
      requireCorrectAnswer
      question
      pairs {
        item {
          icon
          iconColor
          emoji
          label
          value
          activeVisual
        }
        option {
          icon
          iconColor
          emoji
          label
          value
        }
      }
      correctAnswerOrder
    }

    ... on PhraseMatchingItem {
      id
      type
      requireCorrectAnswer
      question
      sentence
      correctAnswerSingle
      options {
        label
        value
      }
      rightAnswerExplanation
      wrongAnswerExplanation
    }
  ... on InfoAccordionItem {
    id
    type
    accordionItems {
      heading
      content
      emoji
    }
    }

    ... on ScrollCardItem {
      id
      type
      cardItems {
        heading
        content
        backgroundImageUrl
      }
    }

    ... on StoryAssetItem {
      id
      type
      storyData
    }
  }

`);

export const learningContentFragment = graphql(`
  fragment LearningContentFields on LearningContent {
    id
    data {
      ...LearningAssetContentDataFields
    }
  }
`);

export const adminLearningContentFragment = graphql(`
  fragment AdminLearningContentFields on AdminLearningContent {
    id
    data {
      ...LearningAssetContentDataFields
    }
  }
`);

export const learningAssetContentDataFragment = graphql(`
  fragment LearningAssetContentDataFields on LearningAssetContent {
    id
    type
    learningAssetContentItems {
      ...BlockUnionFields
    }
  }
`);

export const seoMetaFragment = graphql(`
  fragment SeoMetaFields on SeoMeta {
    title
    description
  }
`);

export const deleteLearningAssetMutation = graphql(`
  mutation deleteLearningAsset($input: DeleteLearningAssetInput!) {
    deleteLearningAsset(input: $input) {
      success
    }
  }
`);
